import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModulesComponent } from '../../../service/modules/modules.component';
import { ServerService } from '../../../service/server/server.service';
import { InsertComponent } from '../../../service/insert/insert.component';
import { MessageService } from '../../../service/message/message.service';
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
  selector: 'app-material-detaile',
  templateUrl: './material-detaile.component.html',
  styleUrls: ['./material-detaile.component.scss']
})
export class MaterialDetaileComponent implements OnInit, OnDestroy {
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public loading: boolean = false;
  public loading2: boolean = false;
  public temp_inventory: number = 0;
  public readonly: boolean = false;
  public subscription: Subscription | any;
  public form1_group: FormGroup | any;
  public search_array: any = [];
  public type_task!: number;
  public server_main!: string;
  public server!: any;
  public site!: any;
  public user_id!: number;
  public id!: number;
  public i!: number;
  public code!: number;
  public result!: any;
  public coding!: string;
  public creator!: number;
  public expire!: boolean;
  public access_service!: number;
  public level!: number;
  public order_id!: number;
  public material_remain!: number;
  public weight_title!: string;
  public last_price_buy!: number;
  public last_date_buy!: number;
  public last_price_sale!: number;
  public last_date_sale!: string;
  public currency_title!: string;
  public last_order_id!: number;

  constructor(
    public serverService: ServerService,
    public router: Router,
    public matSnackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any,
    public dialog: MatDialog,
    public messageService: MessageService,
    public matDialogRef: MatDialogRef<MaterialDetaileComponent>) {
    this.server_main = this.serverService.get_server_main();
    this.server = this.serverService.get_server();
    this.site = this.serverService.get_site();
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    if (dialog_data) {
      this.type_task = dialog_data.type_task;
      this.create_form1();
      this.id = dialog_data.id;
      this.code = dialog_data.code;
      this.readonly = dialog_data.readonly;
      this.creator = dialog_data.creator;
      this.i = dialog_data.i;
      if (this.type_task == 1) {
        this.check_access(5, 1);
      }
      if (this.type_task == 2) {
        this.check_access(4, 1);
      }
    }
  }//end consructor
  ngOnInit() {
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
  }
  create_form1() {
    this.form1_group = new FormGroup({
      'title': new FormControl(null),
      'price': new FormControl(0),
      'price2': new FormControl(0),
      'group_title': new FormControl(null),
      'group': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'cate_title': new FormControl(null),
      'cate': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'inventory': new FormControl(0, [Validators.pattern('[0-9.]{1,}')]),
      'weight_title': new FormControl(null),
      'weight': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'comment': new FormControl(null),
      'coding': new FormControl(null),
    });
    if (this.type_task == 2 || this.type_task == 1) {
      this.form1_group.controls['title'].setValidators([Validators.required]);
      this.form1_group.controls['group'].setValidators([Validators.required]);
      this.form1_group.controls['cate'].setValidators([Validators.required]);
    }
  }
  check_access(type_task: any, excel: number): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1_group.valid && (this.type_task == 1 || this.type_task == 2)) {
      return false;
    }
    this.loading = true;
    var obj = {
      'address': 6,
      'type': 'user',
      'user_id': this.user_id,
      'id': this.code
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any): any => {
        if (res['status'] == 1) {
          this.creator = res['creator'];
          this.level = res['level'];
          this.access_service = res['result'][0].count;
          this.check_access2(type_task, excel, res['result'][0].count);
        }//end if
        else {
          this.message(true, this.messageService.access2(), 1, this.messageService.close());
        }
      }
    )
  }
  check_access2(type_task: any, excel: number, access_service: number): any {
    var obj = {
      'address': 6,
      'user_id': this.creator,
      'id': this.code
    }
    this.subscription = this.serverService.post_address(this.server_main, 'new_address', obj).subscribe(
      (res: any): any => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            this.message(true, this.messageService.access2(), 1, this.messageService.close());
            return false;
          }
          else if (this.level == 3 && access_service == 0) {
            this.message(true, this.messageService.access2(), 1, this.messageService.close());
            return false;
          }
          this.expire = res['expire'];
          if (type_task == 1) {
            if (this.expire == true) {
              this.message(true, this.messageService.expire(), 1, this.messageService.close());
              return false;
            } else {
              this.insert();
            }
          }
          if (type_task == 2) { this.update(); }
          if (type_task == 3) { }
          if (type_task == 4) { this.get_data(); }
          if (type_task == 5) {
            this.get_weight();
          }
        }//end if
        else {
          this.message(true, this.messageService.access(), 1, this.messageService.close());
        }
      }
    )
  }
  get_data() {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 7247,
      'id': this.id,
      'creator': this.creator
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.form1_group.patchValue({
            'title': res['result'][0].wharehouse_material_title,
            'inventory': res['result'][0].wharehouse_material_inventory,
            'price': res['result'][0].wharehouse_material_price,
            'price2': res['result'][0].wharehouse_material_price2,
            'group_title': res['result'][0].wharehouse_group_title,
            'group': res['result'][0].wharehouse_group_id,
            'cate_title': res['result'][0].wharehouse_material_cate_title,
            'cate': res['result'][0].wharehouse_material_cate_id,
            'weight': res['result'][0].wharehouse_weight_id,
            'weight_title': res['result'][0].wharehouse_weight_title,
            'comment': res['result'][0].wharehouse_material_comment,
            'coding': res['result'][0].wharehouse_material_coding,
          }
          );
          this.last_order_id = res['result'][0].wharehouse_material_last_order_id;
          this.temp_inventory = res['result'][0].wharehouse_material_inventory;
          if (res['num_result_order'] == 1) {
            this.order_id = res['result_order'][0].wharehouse_order_id;
          }
          this.weight_title = res['result'][0].wharehouse_weight_title;
          this.get_info_price();
          this.get_currency_title();
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  insert() {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 6037,
      "user_id": this.user_id,
      'price': this.form1_group.value.price,
      'price2': this.form1_group.value.price2,
      'comment': this.form1_group.value.comment,
      'title': this.form1_group.value.title,
      'inventory': this.form1_group.value.inventory,
      'weight': this.form1_group.value.weight,
      'group': this.form1_group.value.group,
      'cate': this.form1_group.value.cate,
      'group2': this.form1_group.value.group2,
      'creator': this.creator,
      'coding': this.form1_group.value.coding
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.result = res['result'][0];
          this.matDialogRef.close(
            { result: this.result }
          )
        }//end if
        else if (res['status'] == 4) {
          this.message(true, this.messageService.repeat(), 1, this.messageService.close());
        }
        else {
          this.message(true, this.messageService.erorr_in_save(), 1, this.messageService.close());
        }
      }
    );
  }//end insert
  update() {
    if (this.form1_group.value.inventory < this.temp_inventory) {
      this.check_inventory();
    } else {
      this.update2();
    }
  }
  check_inventory() {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 6496,
      'material': this.id,
      'order_id': this.order_id,
      'inventory': this.form1_group.value.inventory
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (Number(res['result'][0].consumed) > this.form1_group.value.inventory) {
            var message = "تعدادی درج شده بیشتر ار خروجی انبار می باشد .لطفا اصلاح نمائید.";
            this.message(true, this.messageService.message(message), 1, this.messageService.close());
          }
          else {
            this.update2();
          }
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  update2() {
    var obj = {
      'address': 6038,
      "user_id": this.user_id,
      'title': this.form1_group.value.title,
      'price': this.form1_group.value.price,
      'price2': this.form1_group.value.price2,
      'inventory': this.form1_group.value.inventory,
      'weight': this.form1_group.value.weight,
      'group': this.form1_group.value.group,
      'cate': this.form1_group.value.cate,
      'group2': this.form1_group.value.group2,
      'comment': this.form1_group.value.comment,
      'creator': this.creator,
      'id': this.id,
      'coding': this.form1_group.value.coding,
      'order_id': this.order_id
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.result = { result: res['result'][0], i: this.i };
          this.matDialogRef.close(this.result);
        }//end if
        else if (res['status'] == 4) {
          this.message(true, this.messageService.repeat(), 1, this.messageService.close());
        }
        else {
          this.message(true, this.messageService.erorr_in_save(), 1, this.messageService.close());
        }
      }
    );
  }//end update
  onTabChange(event: MatTabChangeEvent): void {
    if (this.type_task == 2) {
      if (event.index === 1) {
        this.get_info_price();
        this.get_currency_title();
      }
    }
  }
  get_info_price() {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return false;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading2 = true;
    var obj = {
      'address': 7249,
      'id': this.id,
      'creator': this.creator
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1 && res['num'] == 1) {
          this.material_remain = res['material_remain'];
          this.last_price_buy = res['last_price_buy'];
          this.last_date_buy = res['last_date_buy'];
          this.last_price_sale = res['last_price_sale'];
          this.last_date_sale = res['last_date_sale']
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  get_cardex_buy() {
    window.open("/home/cardex/207?material=" + this.id + "&invoiceType=buy", "_blank")
  }
  get_cardex_sale() {
    window.open("/home/cardex/207?material=" + this.id + "&invoiceType=sale", "_blank")
  }
  //*********************************************************************************************************************** */
  get_weight() {
    var obj = {
      'address': 6211,
      'creator': this.creator
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.form1_group.patchValue({
              weight: res['result'][0].wharehouse_weight_id,
              weight_title: res['result'][0].wharehouse_weight_title,
            })
          }
          this.message(false, "", 1, this.messageService.close());
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  get_currency_title() {
    var obj = {
      'address': 6722,
      'creator': this.creator
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.currency_title = res['result'][0].site_currency_title;
          }
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  add_group(): any {
    const dialogRef = this.dialog.open(InsertComponent, {
      width: '20rem',
      height: 'auto',
      data: { creator: this.creator, service: 'group' }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          this.form1_group.patchValue({
            'group_title': res.wharehouse_group_title,
            'group': res.wharehouse_group_id
          })
        }
      }
    )
  }
  add_cate(): any {
    if (!this.form1_group.value.group) {
      var message = "برای درج زیرگروه نیاز است تا گروه انتخاب شده باشد";
      this.message(true, this.messageService.message(message), 1, this.messageService.close());
      return false;
    }
    const dialogRef = this.dialog.open(InsertComponent, {
      width: '20rem',
      height: 'auto',
      data: { creator: this.creator, service: 'cate', group: this.form1_group.value.group }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          this.form1_group.patchValue({
            'cate_title': res.wharehouse_material_cate_title,
            'cate': res.wharehouse_material_cate_id
          })
        }
      }
    )
  }
  load_services(id: number): any {
    if (this.readonly == true) {
      return false;
    }
    var creator = this.creator;
    var code_id;
    if (id == 1841) {
      if (!this.form1_group.value.group) {
        var message = "در ابتدا باید گروه انتخاب شود";
        this.message(true, this.messageService.message(message), 1, this.messageService.close());
        return false;
      }
    }
    if (id == 184) {
      code_id = 6523;
    }
    if (id == 223) {
      code_id = 6346;
    }
    const dialogRef = this.dialog.open(ModulesComponent, {
      width: '40rem',
      height: 'auto',
      disableClose: true,
      data: {
        'id': id,
        'creator': creator,
        'code_id': code_id,
        obj: { group: this.form1_group.value.group, group2: this.form1_group.value.group2 }
      }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          if (id == 223) {
            this.form1_group.patchValue({
              'group': res.id,
              'group_title': res.title,
              'cate': null,
              'cate_title': null
            })
          }
          if (id == 184) {
            this.form1_group.patchValue({
              'cate': res.id,
              'cate_title': res.title
            })
          }
          if (id == 211) {
            this.form1_group.patchValue({
              'weight': res.id,
              'weight_title': res.title
            })
          }
        }
      }
    )
  }
  reset_input(id: number): any {
    if (this.readonly == true) {
      return false;
    }
    if (id == 223) {
      this.form1_group.patchValue({
        'group_title': null,
        'group': null,
        'cate': null,
        'cate_title': null
      })
    }
    if (id == 184) {
      this.form1_group.patchValue({
        'cate_title': null,
        'cate': null

      })
    }
    if (id == 211) {
      this.form1_group.patchValue({
        'weight': null,
        'weight_title': null
      })
    }
  }
  //********************************************************************************************* */
  close() {
    this.matDialogRef.close();
  }
  //********************************************************************************************* */
  required() {
    if (this.type_task == 1 || this.type_task == 2) {
      return true;
    }
    else {
      return false;
    }
  }
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) {
      this.loading = false;
      this.loading2 = false;
    }
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 4000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}